import React, { useState, useEffect } from "react";
import carregando from "../../assets/loading.gif";
import api from '../../services/api';
import Header from '../../Header';
import SideMenu from '../../SideMenu';
import Footer from '../../Footer';
import DataTable from 'react-data-table-component';

export default function List_Integracao({ history }) {
const [prod, setProd] = useState([]);
const [loading, setLoading] = useState("");
const [busca, setBusca] = useState('');
const [rowsSel, setRowsSel] = useState([]);

const empresaid = localStorage.getItem("sgiempresaid");
const isMaster = localStorage.getItem("sgimaster");
const isMasterUser = isMaster === "true";
const ehDaMinhaEmpresa = (row) =>
  row && String(row.idempresa) === String(empresaid);
const podeAlterarTreinamento = (row) => isMasterUser || ehDaMinhaEmpresa(row);

async function loadProd() {
  const query = '/treinamentos/produto/integracao';
  const response = await api.get(query, {
    headers: { "x-tenantid": empresaid, "isMaster": isMaster }
  });

  const data = await response.data;
  setProd((data || []).filter(item => item.titulo && item.titulo.toLowerCase().includes(busca.toLowerCase())))
  setLoading(false);
};

function efetivaBusca(){
  loadProd();
};

const goToPage = (state) => {
  if (!podeAlterarTreinamento(state)) {
    alert(
      "Este treinamento não pertence à sua empresa. Você pode visualizá-lo na lista, mas não editá-lo."
    );
    return;
  }
  history.push('/produto/' + state._id);
};

const columns = [
  {
    name: 'Titulo',
    selector: row => row.titulo,
    sortable: true
  },
  {
    name: 'Descrição',
    selector: row => row.descr,
    sortable: true
  }
];

const handleChange = (state) => {
  setRowsSel(state.selectedRows)
};

  useEffect(() => {
    setLoading(true);
    loadProd();
    setTimeout(() => {
      if(document.getElementById('menu_integracao')){
        document.getElementById('menu_integracao').className = "active";
      }      
    }, 50);
  }, []);

  async function handleRemove(id, item){
    if(rowsSel.length > 0){
      if (window.confirm('Confirma remoção dos itens selecionados ?')){
        setLoading(true);
        rowsSel.map(async (item) => {
            await api.delete('/treinamentos/produto/' + item._id, {
              headers: { "x-tenantid": empresaid, isMaster },
            }).then((res) => {
              if(res.data.error != undefined){
                  alert(res.data.error);
                  setLoading(false);
                  return;
              } else {
                loadProd();
                setLoading(false);
              }
          }).catch((error) => {
              alert(error);
              setLoading(false);
              return;
          });    
        });
      }
  } else {
    alert("Nenhum registro selecionado !")
  }
};

  return (
    <>

    <Header/>
    <SideMenu/>

    <div>
        <div className="content-wrapper">

            <section className="content-header">
                <h1>
                    Integração<small>( tabela integração )</small>
                </h1>
            </section>

            <section className="content">
                <div className="row">
                    <div className="col-xs-12">
                        <div className="box">
                        {loading && (
                          <div style={{ alignItems: "center", textAlign: "center" }}>
                            <img src={carregando} width="80" alt=""></img>
                          </div>
                        )}
                        <div className="box-body table-responsive">
                            

                            <div className="col-md-12 nopadding">
                        <div className="col-md-6 nopadding">
                        <button type="button" className="btn btn-success btn-flat margin" onClick={() => {history.push('/produto/novo?integracao=1')}}>Nova Integração</button>
                          <button type="button" className="btn btn-danger btn-flat margin" onClick={() => {handleRemove('','')}}>Remover Selecionados</button>
                          </div>
                          <div className="col-md-6 text-right" style={{paddingTop:10}}>
                          <input
                              placeholder={"Buscar por Nome"}
                              value={busca}
                              onChange={event => setBusca(event.target.value)}
                            />
                            <button 
                              onClick={efetivaBusca}
                            >
                              Buscar
                            </button>
                            </div>
                          </div>
                        

                            <DataTable
                          columns={columns}
                          data={prod}
                          onRowClicked={goToPage}
                          selectableRows
                          selectableRowDisabled={(row) =>
                            !isMasterUser && !ehDaMinhaEmpresa(row)
                          }
                          pointerOnHover
                          highlightOnHover
                          onSelectedRowsChange={handleChange}
                          noDataComponent={''}
                        />

                            </div>

                         
                        </div>
                        {/* /.box */}
                    </div>
                </div>
            </section>
            {/* /.content */}
        </div>
    </div>
    
    <Footer/>
    </>
)
}


//nome, 
//descr, 
//preco, 
//imagem, 
//promocao, 
//idestabelecimento
